<template>
  <div class="row">
    <div class="error-col">
      <h3 class="pb-2 mt-4 mb-2 border-bottom">404 Error</h3>
      <p>Not Found</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound",
};
</script>

<style>
.error-col {
  padding: 20px 40px 20px 40px;
  position: relative;
  width: 100%;
  min-height: 1px;
  flex: 0 0 100%;
  max-width: 100%;
}

.error-col > h3 {
  font-size: 1.75rem;
  margin-top: 1.5rem !important;
  padding-bottom: 0.5rem !important;
  margin-bottom: 0.5rem !important;
  border-bottom: 1px solid #dee2e6 !important;
}
</style>
